"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedtag = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 62 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedtag` : '') + (description ? ` desc-brandedtag` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedtag"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedtag"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.33 15.1 51.38 1.5a1.62 1.62 0 0 0-2.06-.95L12.79 13.82c-.4.15-.73.45-.91.84l-5.1 11.96 11.12-.49 6.02 11.48-18.86-6.63c-.13.29-.18.6-.13.9l.05.25c.04.09.07.16.13.23.15.26.4.48.67.6l16.9 11.33c.4.18.84.2 1.24.06l30.3-13.27c.83-.3 1.26-1.23.96-2.06l1.26-13.59-.11-.33Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.99 29.82V17c0-3-1.99-4-3.49-4h-37c-2.35 0-3.35.5-4.5 1.5l-14 14c-.23.24-.9.92-.96 1.24L2 30s.01.18.04.26c.06.32.73 1.01.96 1.24l14 14c1.5 1.5 2 1.5 4.5 1.5h37c1.5 0 3.49-1.5 3.5-5l-.01-11.82v-.36Zm-48.65 2.5a3.3 3.3 0 0 1-.99-2.33 3.3 3.3 0 0 1 .99-2.31 3.43 3.43 0 0 1 4.81 0 3.3 3.3 0 0 1 1 2.33c-.02.87-.37 1.7-1 2.32a3.44 3.44 0 0 1-4.81 0v-.01Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.5 13h-1.44a92.45 92.45 0 0 1-40.11 32.5H17c1.5 1.5 2 1.5 4 1.5h37.5c2.5 0 3.5-3 3.49-4.5V17c.01-3-1.99-4-3.49-4Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43 23h-5.07a2.9 2.9 0 0 0-2.07.88A3.03 3.03 0 0 0 35 26c0 4.5 8 4.5 8 9 0 .8-.3 1.56-.86 2.12a2.9 2.9 0 0 1-2.07.88H35",
    stroke: "#FFF5EB",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39 23v-3",
    stroke: "#FFF5EB",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39 38v4",
    stroke: "#FFF5EB",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = brandedtag;